module.exports = __webpack_public_path__ + "img/lx3.52d35179.png";